import { createAction, handleActions } from 'redux-actions'

const setData = createAction('SCREENS/PLANNER/SUBCONTRACTOR_POPOVER/SET_DATA')
const resetData = createAction('SCREENS/PLANNER/SUBCONTRACTOR_POPOVER/RESET_DATA')

const defaultState = []

const reducer = handleActions(
  {
    [setData]: (state, action) => action.payload,
    [resetData]: () => defaultState,
  },
  defaultState,
)

export { setData, resetData, reducer }
